module.exports = __webpack_public_path__ + "img/default.cea4e91a.png";